import { ButtonProps, TextProps } from '@chakra-ui/react';
import { Button, Text } from 'components/UI';
import { specialFont } from 'constants/theme';

export type HighlightButtonProps = ButtonProps & {
  first?: string;
  second?: string;
  firstProps?: TextProps;
  secondProps?: TextProps;
  multiline?: boolean;
};

const HighlightButton = ({ first, second, firstProps, secondProps, multiline, ...props }: HighlightButtonProps) => {
  const secondTextProps = multiline
    ? {
        mt: 1,
      }
    : {
        ml: 1,
      };

  const buttonProps = multiline
    ? {
        display: 'block',
      }
    : {};

  const sx = {
    fontFamily: specialFont,
    letterSpacing: 3,
    lineHeight: 1,
    fontSize: 'sm',
    color: 'primaryFontColour.400',
  };

  const renderFirst = first ? (
    <Text {...firstProps} sx={sx}>
      {first}{' '}
    </Text>
  ) : null;

  const renderSecond = second ? (
    <Text {...secondTextProps} {...secondProps} sx={{ ...sx, fontWeight: 'bold' }}>
      {second}
    </Text>
  ) : null;

  return (
    <Button {...buttonProps} {...props}>
      {renderFirst}
      {renderSecond}
    </Button>
  );
};

export default HighlightButton;
